<template>
  <div class="h-full px-4 sm:px-6 lg:px-8 pt-6 pb-6 flex flex-col md:flex-row gap-6 lg:gap-8">

    <!-- Sidebar / File Explorer -->
    <aside class="w-full md:w-48 lg:w-56 flex-shrink-0 overflow-y-auto">
      <div class="mb-4">
        <h3 class="text-xs font-bold text-gray-500 tracking-widest uppercase mb-4">Explorer</h3>
        <div class="flex items-center text-sm font-semibold text-white mb-2 cursor-pointer select-none" @click="folderOpen = !folderOpen">
          <svg :class="['w-4 h-4 mr-2 text-yellow-400 transition-transform', folderOpen ? 'rotate-90' : '']" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5l8 7-8 7z"/></svg>
          <svg class="w-4 h-4 mr-2 text-yellow-400" fill="currentColor" viewBox="0 0 24 24"><path d="M10 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/></svg>
          portfolio
        </div>
        <ul v-show="folderOpen" class="sidebar-list space-y-2">
          <li class="relative cursor-pointer group" @click="onFileClick('whoami')">
            <span class="flex items-center text-sm text-primary group-hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5 mr-1.5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                whoami.sh
            </span>
          </li>
          <li class="relative cursor-pointer group" @click="onFileClick('skills')">
            <span class="flex items-center text-sm text-primary group-hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5 mr-1.5 text-yellow-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/></svg>
                skills.json
            </span>
          </li>
          <li class="relative cursor-pointer group" @click="onFileClick('system')">
            <span class="flex items-center text-sm text-primary group-hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5 mr-1.5 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                system.info
            </span>
          </li>
          <li class="relative cursor-pointer group" @click="onFileClick('experience')">
            <span class="flex items-center text-sm text-primary group-hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5 mr-1.5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/></svg>
                experience.log
            </span>
          </li>
          <li class="relative cursor-pointer group" @click="onFileClick('education')">
            <span class="flex items-center text-sm text-primary group-hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5 mr-1.5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg>
                education.md
            </span>
          </li>
          <li class="relative cursor-pointer group" @click="onFileClick('stack')">
            <span class="flex items-center text-sm text-primary group-hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5 mr-1.5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
                stack.conf
            </span>
          </li>
          <li class="relative cursor-pointer group" @click="onFileClick('achievements')">
            <span class="flex items-center text-sm text-primary group-hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5 mr-1.5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
                achievements.log
            </span>
          </li>
          <li class="relative cursor-pointer group" @click="onFileClick('contact')">
            <span class="flex items-center text-sm text-primary group-hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5 mr-1.5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                contact.sh
            </span>
          </li>
          <li class="relative cursor-pointer group" @click="onFileClick('projects')">
            <span class="flex items-center text-sm text-primary group-hover:text-white transition-colors">
                <svg class="w-3.5 h-3.5 mr-1.5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg>
                projects.md
            </span>
          </li>
        </ul>
      </div>
    </aside>

    <!-- Terminal Window -->
    <main class="flex-1 min-h-0">
      <div class="bg-dark rounded-xl border border-gray-800 shadow-2xl overflow-hidden flex flex-col h-full terminal-glow">
        <!-- Terminal Header -->
        <div class="flex items-center px-4 py-3 bg-[#1e2329] border-b border-gray-800">
          <div class="flex space-x-2">
            <div class="w-3 h-3 rounded-full bg-red-500"></div>
            <div class="w-3 h-3 rounded-full bg-yellow-500"></div>
            <div class="w-3 h-3 rounded-full bg-green-500"></div>
          </div>
          <div class="flex-1 text-center text-xs text-gray-500 font-medium">
            whoami.sh - zsh - 80x24
          </div>
        </div>

        <!-- Terminal Body -->
        <div ref="terminalBody" class="terminal-body p-6 md:p-8 flex-1 overflow-y-auto" @click="focusInput">
          <div class="font-mono text-sm">

            <!-- History entries -->
            <div v-for="entry in terminalHistory" :key="entry.id">
              <template v-if="entry.type === 'command'">
                <div class="flex">
                  <span class="text-green-400 whitespace-nowrap">pardi@portfolio:~$</span>
                  <span class="text-white ml-2 whitespace-pre-wrap">{{ entry.content }}</span>
                </div>
              </template>
              <template v-else-if="entry.profile">
                <div class="flex flex-col items-center md:flex-row md:items-start gap-4 md:gap-6">
                  <img src="@/assets/css/profil.png" alt="Pardiyono" class="w-[300px] h-[300px] rounded-lg object-cover flex-shrink-0" />
                  <div class="text-center md:text-left md:mt-0 mt-2">
                    <div class="text-white font-bold text-2xl mb-1">{{ entry.profileData.name }}</div>
                    <div class="text-gray-400 text-sm mb-3">{{ entry.profileData.role }}</div>
                    <div class="hidden md:block">
                      <div v-for="(item, idx) in entry.profileData.info" :key="idx">
                        <span class="text-blue-400">{{ item.label }}</span>
                        <span class="text-white">{{ item.value }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="text-white whitespace-pre-wrap">{{ entry.content }}</div>
              </template>
            </div>

            <!-- Current typing display -->
            <div v-if="isTyping" class="flex">
              <span class="text-green-400 whitespace-nowrap">pardi@portfolio:~$</span>
              <span class="text-white ml-2">{{ currentLineContent }}</span>
              <span class="inline-block w-2 h-4 bg-primary animate-pulse ml-0.5 translate-y-0.5"></span>
            </div>

            <!-- Command Input -->
            <div class="text-green-400 mt-1">pardi@portfolio:~$</div>
              <input
                ref="cmdInput"
                v-model="cmdInputValue"
                @keydown.enter="onCommandSubmit"
                @keydown="onKeydown"
                class="flex-1 bg-transparent border-none outline-none text-white font-mono text-sm caret-primary"
                placeholder="Type a command..."
                autocomplete="off"
                spellcheck="false"
              />

          </div>
        </div>

        <!-- Terminal Footer -->
        <!-- <div class="border-t border-gray-800/60 p-6 flex flex-wrap gap-4 items-center">

        </div> -->
      </div>
    </main>

  </div>
</template>

<script>
const FILES = {
  whoami: {
    command: './whoami.sh',
    phases: [
      'Initializing profile...',
      'Loading identity...',
      'Loading skills...',
      'Done.'
    ],
    output: [
      '╭──────────────────────────────╮',
      '│ PARDIYONO                    │',
      '│ Full Stack Developer         │',
      '╰──────────────────────────────╯',
      '',
      'Nama: Pardiyono',
      'Role: Full Stack Developer',
      'Bio: Full stack developer yang berpengalaman di web development, GIS, dan integrasi AI. Terbiasa build project dari nasi sampai deploy.'
    ]
  },
  skills: {
    command: 'cat skills.json',
    output: [
      '{',
      '  "languages": [',
      '    "PHP",',
      '    "Python",',
      '    "JavaScript",',
      '    "Dart"',
      '  ],',
      '  "frameworks": [',
      '    "Laravel",',
      '    "Vue.js",',
      '    "Django",',
      '    "Flutter"',
      '  ],',
      '  "database": [',
      '    "MySQL",',
      '    "PostgreSQL",',
      '    "MongoDB"',
      '  ],',
      '  "tools": [',
      '    "Git",',
      '    "GitHub",',
      '    "Linux"',
      '  ]',
      '}'
    ]
  },
  system: {
    command: 'neofetch',
    output: [
      '        ██████╗  ██████╗',
      '        ██╔══██╗██╔════╝',
      '        ██████╔╝██║',
      '        ██╔═══╝ ██║',
      '        ██║     ╚██████╗',
      '        ╚═╝      ╚═════╝',
      '',
      'OS          Fedora Linux',
      'Shell       Fish',
      'Editor      Neovim, Zed',
      'Role        Full Stack Developer'
    ],
    outputStyled: [
      { text: '        ██████╗  ██████╗\n', color: 'text-blue-400' },
      { text: '        ██╔══██╗██╔════╝\n', color: 'text-blue-400' },
      { text: '        ██████╔╝██║\n', color: 'text-blue-400' },
      { text: '        ██╔═══╝ ██║\n', color: 'text-blue-400' },
      { text: '        ██║     ╚██████╗\n', color: 'text-blue-400' },
      { text: '        ╚═╝      ╚═════╝\n', color: 'text-blue-400' },
      { text: '\n' },
      { text: 'OS          ', color: 'text-blue-400' }, { text: 'Fedora Linux\n' },
      { text: 'Shell       ', color: 'text-blue-400' }, { text: 'Fish\n' },
      { text: 'Editor      ', color: 'text-blue-400' }, { text: 'Neovim, Zed\n' },
      { text: 'Role        ', color: 'text-blue-400' }, { text: 'Full Stack Developer\n' },
    ]
  },
  experience: {
    command: 'cat experience.log',
    output: [
      '[OK] IT Support  - Bank Sulselbar (banksulselbar.co.id)',
      '[OK] IT          - Bisnis Indonesia Bandung',
      '[OK] IT          - Bappeda Kabupaten Bungo',
      '',
      '[INFO] Web Development, GIS, AI Integration'
    ]
  },
  education: {
    command: 'cat education.md',
    output: [
      '1. Universitas Komputer Indonesia Bandung',
      '   2012',
      '',
      '2. Universitas Muhammadiyah Muara Bungo',
      '   2024'
    ]
  },
  stack: {
    command: 'cat stack.conf',
    output: [
      '[backend]',
      'php=true',
      'python=true',
      'laravel=true',
      'django=true',
      '',
      '[frontend]',
      'javascript=true',
      'vue=true',
      'flutter=true',
      '',
      '[database]',
      'mysql=true',
      'postgresql=true',
      'mongodb=true',
      '',
      '[tools]',
      'git=true',
      'linux=true'
    ]
  },
  achievements: {
    command: 'cat achievements.log',
    output: [
      '[DONE] Web Development Projects',
      '[DONE] GIS Development',
      '[DONE] IT Support Bank',
      '[DONE] IT Bappeda Kabupaten Bungo',
      '[RUN]  Building Next Chapter...'
    ]
  },
  contact: {
    command: './contact.sh',
    output: [
      '╭─────────────────────────────╮',
      '│       CONTACT PARDIYONO     │',
      '╰─────────────────────────────╯',
      '',
      'GitHub:    github.com/pardiyono21',
      'Instagram: @pardi.inc'
    ]
  },
  projects: {
    command: 'cat projects.md',
    output: [
      '[PROJECT] Sistem Informasi Geografis (SIG)',
      '  Tech  : Laravel, Vue.js, PostgreSQL, PostGIS',
      '  Desc  : Web GIS untuk Bappeda Kab. Bungo',
      '',
      '[PROJECT] Masterplan AI',
      '  Tech  : Python, Django, OpenAI API',
      '  Desc  : AI-powered planning tool',
      '',
      '[PROJECT] Web Masjid',
      '  Tech  : Laravel, Bootstrap, MySQL',
      '  Desc  : Website manajemen masjid',
      '',
      '[PROJECT] Sistem Cuti',
      '  Tech  : Laravel, Vue.js, MySQL',
      '  Desc  : Aplikasi pengajuan cuti karyawan'
    ]
  }
}

const VIRTUAL_FS = [
  { name: 'whoami.sh', fileId: 'whoami', type: 'file', icon: '🔧' },
  { name: 'skills.json', fileId: 'skills', type: 'file', icon: '📄' },
  { name: 'system.info', fileId: 'system', type: 'file', icon: '💻' },
  { name: 'experience.log', fileId: 'experience', type: 'file', icon: '📋' },
  { name: 'education.md', fileId: 'education', type: 'file', icon: '🎓' },
  { name: 'stack.conf', fileId: 'stack', type: 'file', icon: '⚙️' },
  { name: 'achievements.log', fileId: 'achievements', type: 'file', icon: '🏆' },
  { name: 'projects.md', fileId: 'projects', type: 'file', icon: '📁' },
  { name: 'contact.sh', fileId: 'contact', type: 'file', icon: '📧' },
]

const HELP_TEXT = [
  'Available commands:',
  '  whoami     - Display user profile',
  '  skills     - Show skills list',
  '  system     - Display system info',
  '  experience - Show experience log',
  '  education  - Show education background',
  '  stack      - Show tech stack config',
  '  projects   - Show projects list',
  '  achievements - Show achievements',
  '  contact    - Show contact information',
  '  history    - Show command history',
  '  help       - Show this help',
  '  clear      - Clear terminal',
  '  ls         - List files'
]

export default {
  name: 'HomeView',
  data() {
    return {
      terminalHistory: [],
      currentLineContent: '',
      isTyping: false,
      typingSpeed: 5,
      phaseSpeed: 20,
      currentEntryId: 0,
      cmdInputValue: '',
      currentFileId: null,
      commandHistory: [],
      commandHistoryIndex: -1,
      folderOpen: true
    }
  },
  mounted() {
    this.folderOpen = window.innerWidth >= 768
    this.terminalHistory.push({
      id: String(this.terminalHistory.length + 1),
      profile: true,
      profileData: {
        name: 'PARDIYONO',
        role: 'Full Stack Developer',
        info: [
          { label: 'OS      ', value: 'Fedora Linux' },
          { label: 'Shell   ', value: 'Fish' },
          { label: 'Editor  ', value: 'Neovim, Zed' },
          { label: 'Role    ', value: 'Full Stack Developer' },
          { label: 'PHP     ', value: 'Laravel, CodeIgniter' },
          { label: 'Python  ', value: 'Django' },
          { label: 'JS      ', value: 'Vue.js' },
          { label: 'Mobile  ', value: 'Flutter' },
          { label: 'DB      ', value: 'MySQL, PostgreSQL, MongoDB' },
          { label: 'Git     ', value: 'GitHub pardiyono21' },
        ]
      }
    })
    this.$nextTick(() => this.scrollToBottom())
  },
  methods: {
    onFileClick(fileId) {
      if (this.isTyping) return
      const fileData = FILES[fileId]
      if (!fileData) return

      this.currentFileId = fileId
      this.runCommand(fileData.command, fileData.phases || null, fileData.output || null)
    },
async runCommand(command, phases, output) {
      const entryId = String(this.terminalHistory.length + 1)

      // Phase 1: Type the command
      this.isTyping = true
      this.currentEntryId = entryId
      this.currentLineContent = ''

      for (let i = 0; i < command.length; i++) {
        this.currentLineContent = command.substring(0, i + 1)
        await this.wait(this.typingSpeed)
        this.scrollToBottom()
      }

      this.terminalHistory.push({
        id: entryId,
        type: 'command',
        content: command
      })

      this.currentEntryId = 0
      this.currentLineContent = ''
      this.isTyping = false
      this.scrollToBottom()

      // Phase 2: If there are phases, type them
      if (phases) {
        for (const phase of phases) {
          const phaseEntryId = String(this.terminalHistory.length + 1)
          this.currentEntryId = phaseEntryId
          this.currentLineContent = ''

          for (let i = 0; i < phase.length; i++) {
            this.currentLineContent = phase.substring(0, i + 1)
            await this.wait(this.phaseSpeed)
            this.scrollToBottom()
          }

          this.terminalHistory.push({
            id: phaseEntryId,
            content: phase
          })

          this.currentEntryId = 0
          this.currentLineContent = ''
          this.isTyping = false
          this.scrollToBottom()
          await this.wait(100)
        }
      }

      // Phase 3: Type the output lines
      if (this.currentFileId === 'system') {
        const outEntryId = String(this.terminalHistory.length + 1)
        this.terminalHistory.push({
          id: outEntryId,
          profile: true,
          profileData: {
            name: 'PARDIYONO',
            role: 'Full Stack Developer',
            info: [
              { label: 'OS      ', value: 'Fedora Linux' },
              { label: 'Shell   ', value: 'Fish' },
              { label: 'Editor  ', value: 'Neovim, Zed' },
              { label: 'Role    ', value: 'Full Stack Developer' },
              { label: 'PHP     ', value: 'Laravel, CodeIgniter' },
              { label: 'Python  ', value: 'Django' },
              { label: 'JS      ', value: 'Vue.js' },
              { label: 'Mobile  ', value: 'Flutter' },
              { label: 'DB      ', value: 'MySQL, PostgreSQL, MongoDB' },
              { label: 'Git     ', value: 'GitHub pardiyono21' },
            ]
          }
        })
        this.scrollToBottom()
      } else {
        const outputLines = output || []
        for (const line of outputLines) {
          const outEntryId = String(this.terminalHistory.length + 1)
          this.currentEntryId = outEntryId
          this.currentLineContent = ''
          this.isTyping = true

          for (let i = 0; i < line.length; i++) {
            this.currentLineContent = line.substring(0, i + 1)
            await this.wait(this.typingSpeed)
            this.scrollToBottom()
          }

          this.terminalHistory.push({
            id: outEntryId,
            content: line
          })

          this.currentEntryId = 0
          this.currentLineContent = ''
          this.isTyping = false
          this.scrollToBottom()
          await this.wait(30)
        }
      }

      this.scrollToBottom()
    },
    onCommandSubmit() {
      if (this.isTyping) return
      const cmd = this.cmdInputValue.trim()
      if (!cmd) return

      this.commandHistory.push(cmd)
      this.commandHistoryIndex = this.commandHistory.length
      this.cmdInputValue = ''
      this.runUserCommand(cmd)
    },
    onKeydown(e) {
      if (e.key === 'ArrowUp') {
        e.preventDefault()
        if (this.commandHistoryIndex > 0) {
          this.commandHistoryIndex--
          this.cmdInputValue = this.commandHistory[this.commandHistoryIndex]
        }
      } else if (e.key === 'ArrowDown') {
        e.preventDefault()
        if (this.commandHistoryIndex < this.commandHistory.length - 1) {
          this.commandHistoryIndex++
          this.cmdInputValue = this.commandHistory[this.commandHistoryIndex]
        } else {
          this.commandHistoryIndex = this.commandHistory.length
          this.cmdInputValue = ''
        }
      }
    },
    async runUserCommand(rawCmd) {
      const cmd = rawCmd.toLowerCase().trim()
      const entryId = String(this.terminalHistory.length + 1)

      // Type the user command
      this.isTyping = true
      this.currentEntryId = entryId
      this.currentLineContent = ''

      for (let i = 0; i < rawCmd.length; i++) {
        this.currentLineContent = rawCmd.substring(0, i + 1)
        await this.wait(this.typingSpeed)
        this.scrollToBottom()
      }

      this.terminalHistory.push({
        id: entryId,
        type: 'command',
        content: rawCmd
      })

      this.currentEntryId = 0
      this.currentLineContent = ''
      this.isTyping = false
      this.scrollToBottom()
      await this.wait(50)

      // Handle commands
      if (cmd === 'clear') {
        this.terminalHistory = []
        this.scrollToBottom()
        return
      }

      if (cmd === 'history') {
        if (this.commandHistory.length === 0) {
          const eid = String(this.terminalHistory.length + 1)
          this.terminalHistory.push({ id: eid, content: 'No commands in history.' })
        } else {
          for (let i = 0; i < this.commandHistory.length; i++) {
            const eid = String(this.terminalHistory.length + 1)
            this.terminalHistory.push({ id: eid, content: `  ${i + 1}  ${this.commandHistory[i]}` })
          }
        }
        this.scrollToBottom()
        return
      }

      if (cmd === 'help') {
        for (const line of HELP_TEXT) {
          const eid = String(this.terminalHistory.length + 1)
          this.currentEntryId = eid
          this.currentLineContent = ''
          this.isTyping = true

          for (let i = 0; i < line.length; i++) {
            this.currentLineContent = line.substring(0, i + 1)
            await this.wait(this.typingSpeed)
            this.scrollToBottom()
          }

          this.terminalHistory.push({ id: eid, content: line })
          this.currentEntryId = 0
          this.currentLineContent = ''
          this.isTyping = false
          this.scrollToBottom()
          await this.wait(20)
        }
        this.scrollToBottom()
        return
      }

      if (cmd === 'ls') {
        for (const f of VIRTUAL_FS) {
          const eid = String(this.terminalHistory.length + 1)
          this.currentEntryId = eid
          this.currentLineContent = ''
          this.isTyping = true

          for (let i = 0; i < f.name.length; i++) {
            this.currentLineContent = f.name.substring(0, i + 1)
            await this.wait(this.typingSpeed)
            this.scrollToBottom()
          }

          this.terminalHistory.push({ id: eid, content: f.name })
          this.currentEntryId = 0
          this.currentLineContent = ''
          this.isTyping = false
          this.scrollToBottom()
          await this.wait(20)
        }
        this.scrollToBottom()
        return
      }

      // Match file command
      // .sh: ./whoami.sh, whoami.sh, whoami
      // .json/.log/.md/.conf: cat skills.json, skills.json, skills
      const cleanCmd = cmd.replace(/^\.\//, '').replace(/^\//, '')
      const match = VIRTUAL_FS.find(f => {
        const fname = f.name.replace(/\//, '')
        if (fname.endsWith('.sh')) {
          return cleanCmd === fname || cleanCmd === f.fileId || cleanCmd === fname.replace(/\.[^.]+$/, '')
        } else {
          return cmd === fname || cmd === f.fileId || cmd === fname.replace(/\.[^.]+$/, '')
            || cmd === 'cat ' + fname
        }
      })
      if (match && match.fileId) {
        this.onFileClick(match.fileId)
        return
      }

      // Command not found
      const eid = String(this.terminalHistory.length + 1)
      this.currentEntryId = eid
      this.currentLineContent = ''
      this.isTyping = true
      const errMsg = `command not found: ${cmd}`

      for (let i = 0; i < errMsg.length; i++) {
        this.currentLineContent = errMsg.substring(0, i + 1)
        await this.wait(this.typingSpeed)
        this.scrollToBottom()
      }

      this.terminalHistory.push({ id: eid, content: errMsg })
      this.currentEntryId = 0
      this.currentLineContent = ''
      this.isTyping = false
      this.scrollToBottom()
      await this.wait(30)
      this.scrollToBottom()
    },
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.terminalBody
        if (el) el.scrollTop = el.scrollHeight
      })
    },
    focusInput() {
      this.$nextTick(() => {
        if (this.$refs.cmdInput) this.$refs.cmdInput.focus()
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0
}

.terminal-body::-webkit-scrollbar {
  width: 4px;
}
.terminal-body::-webkit-scrollbar-track {
  background: transparent;
}
.terminal-body::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 2px;
}
.terminal-body::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

aside::-webkit-scrollbar {
  width: 3px;
}
aside::-webkit-scrollbar-track {
  background: transparent;
}
aside::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 2px;
}

.sidebar-list {
  list-style: none !important;
  margin-left: 1.75rem;
  padding: 0 20px;
  border-left: 1px solid #1f2937;
}

.terminal-glow {
  box-shadow: 0 0 15px rgba(74, 222, 128, 0.15),
              0 0 30px rgba(74, 222, 128, 0.05),
              inset 0 1px 0 rgba(74, 222, 128, 0.1);
  border-color: rgba(74, 222, 128, 0.3);
  animation: glow-pulse 3s ease-in-out infinite;
}

@keyframes glow-pulse {
  0%, 100% {
    box-shadow: 0 0 15px rgba(74, 222, 128, 0.15),
                0 0 30px rgba(74, 222, 128, 0.05),
                inset 0 1px 0 rgba(74, 222, 128, 0.1);
    border-color: rgba(74, 222, 128, 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(74, 222, 128, 0.25),
                0 0 40px rgba(74, 222, 128, 0.1),
                inset 0 1px 0 rgba(74, 222, 128, 0.15);
    border-color: rgba(74, 222, 128, 0.5);
  }
}
</style>
